import {returnOrderCodesSortedByCodeSelector} from '../../../data/returnOrderCodes.js'
import {
  currentReturnOrderCodeIDSelector,
  isNewReturnOrderCodeSelector,
} from './returnOrderCodesFunctions.js'
import CodeListItem from './CodeListItem.js'
import {useSelector} from '../../../store.js'

export default function CodeList() {
  const returnOrderCodes = useSelector(returnOrderCodesSortedByCodeSelector)
  const currentReturnOrderCodeID = useSelector(currentReturnOrderCodeIDSelector)
  const isNew = useSelector(isNewReturnOrderCodeSelector)

  return (
    <div className="medium-12 columns">
      <ul className="settings-list">
        {returnOrderCodes.map((code) => (
          <CodeListItem
            key={code.id}
            returnOrderCodeID={code.id}
            isExpanded={code.id === currentReturnOrderCodeID}
          />
        ))}
        <CodeListItem isExpanded={isNew} />
      </ul>
    </div>
  )
}
